import React from 'react'
import styled from 'styled-components'
import { Link } from './link'
import { StaticImage } from 'gatsby-plugin-image'

const Container = styled.section`
  padding: 2rem;
  background: ${({theme}) => theme.darkWhite.hex};
  @media(min-width: 768px) {
    padding: 4rem;
  }
`
const FlexWrapper = styled(Link)`
  display: flex;
  background: ${({theme}) => theme.darkGray.hex};
  align-items: center;
  justify-content: center;
  max-height: 25vh;
  margin: 0 auto;
  overflow: hidden;

  &>* {
    flex: 1 1 50%;
  }

  @media(min-width: 768px) {
    max-height: 50vh;
    max-width: 75vw;
  }
`
const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 1rem;
  padding-right: 1rem;
`

const SvgText = (props) => {
  return (
    <svg
      viewBox="0 0 262 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.18 26.93c0-1.203-.43-2.14-1.29-2.813-.843-.672-2.335-1.367-4.476-2.086-2.14-.718-3.89-1.414-5.25-2.086-4.422-2.172-6.633-5.156-6.633-8.953 0-1.89.547-3.555 1.64-4.992 1.11-1.453 2.673-2.578 4.688-3.375 2.016-.813 4.282-1.219 6.797-1.219 2.453 0 4.649.438 6.586 1.313 1.953.875 3.469 2.125 4.547 3.75 1.078 1.61 1.617 3.453 1.617 5.531h-8.203c0-1.39-.43-2.469-1.289-3.234C17.07 8 15.922 7.617 14.47 7.617c-1.469 0-2.633.328-3.492.985-.844.64-1.266 1.46-1.266 2.46 0 .876.469 1.672 1.406 2.391.938.703 2.586 1.438 4.945 2.203 2.36.75 4.297 1.563 5.813 2.438 3.688 2.125 5.531 5.054 5.531 8.789 0 2.984-1.125 5.328-3.375 7.031-2.25 1.703-5.336 2.555-9.258 2.555-2.765 0-5.273-.492-7.523-1.477-2.234-1-3.922-2.36-5.063-4.078C1.063 29.18.5 27.187.5 24.937h8.25c0 1.829.469 3.18 1.406 4.055.953.86 2.492 1.29 4.617 1.29 1.36 0 2.43-.29 3.211-.868.797-.594 1.196-1.422 1.196-2.484zm18.364-13.57c1.688-2.126 3.844-3.188 6.47-3.188 2.796 0 4.905.828 6.327 2.484 1.422 1.656 2.149 4.102 2.18 7.336V36h-7.922V20.18c0-1.344-.273-2.328-.82-2.953-.547-.641-1.477-.961-2.79-.961-1.624 0-2.773.515-3.445 1.547V36h-7.898V0h7.898v13.36zm16.935 9.726c0-2.531.493-4.781 1.477-6.75.984-1.984 2.398-3.508 4.242-4.57 1.844-1.063 4.008-1.594 6.492-1.594 3.797 0 6.79 1.18 8.977 3.539 2.187 2.344 3.281 5.539 3.281 9.586v.281c0 3.953-1.101 7.094-3.305 9.422-2.187 2.313-5.156 3.469-8.906 3.469-3.61 0-6.508-1.078-8.695-3.235-2.188-2.172-3.367-5.109-3.54-8.812l-.023-1.336zm7.899.492c0 2.344.367 4.063 1.101 5.156.735 1.094 1.82 1.641 3.258 1.641 2.813 0 4.25-2.164 4.313-6.492v-.797c0-4.547-1.453-6.82-4.36-6.82-2.64 0-4.07 1.96-4.289 5.882l-.023 1.43zm42.154-.07c0 3.937-.891 7.086-2.672 9.445-1.766 2.344-4.157 3.516-7.172 3.516-2.328 0-4.242-.852-5.742-2.555V45.75h-7.899V10.64h7.383l.234 2.344c1.516-1.875 3.508-2.812 5.977-2.812 3.125 0 5.555 1.156 7.289 3.469 1.734 2.296 2.602 5.46 2.602 9.492v.375zm-7.899-.492c0-4.5-1.312-6.75-3.937-6.75-1.875 0-3.125.672-3.75 2.015v9.985c.687 1.406 1.953 2.109 3.797 2.109 2.515 0 3.812-2.172 3.89-6.516v-.843zM117.472 36V1.875h10.992c3.016 0 5.727.688 8.133 2.063 2.406 1.359 4.281 3.289 5.625 5.789 1.359 2.484 2.047 5.273 2.062 8.367v1.57c0 3.125-.664 5.93-1.992 8.414a14.47 14.47 0 01-5.578 5.813c-2.391 1.39-5.062 2.093-8.016 2.109h-11.226zm8.226-27.773v21.445h2.86c2.359 0 4.172-.836 5.437-2.508 1.266-1.687 1.899-4.187 1.899-7.5v-1.477c0-3.296-.633-5.78-1.899-7.453-1.265-1.671-3.109-2.507-5.531-2.507h-2.766zm33.271 28.242c-3.89 0-7.039-1.157-9.445-3.469-2.406-2.328-3.609-5.352-3.609-9.07v-.657c0-2.593.476-4.882 1.429-6.867.969-1.984 2.375-3.515 4.219-4.593 1.844-1.094 4.031-1.641 6.563-1.641 3.562 0 6.375 1.11 8.437 3.328 2.063 2.203 3.094 5.281 3.094 9.234v3.07h-15.703c.281 1.423.898 2.54 1.851 3.352.953.813 2.188 1.219 3.703 1.219 2.5 0 4.454-.875 5.86-2.625l3.609 4.266c-.984 1.359-2.383 2.445-4.195 3.257-1.797.797-3.734 1.196-5.813 1.196zm-.89-20.203c-2.313 0-3.688 1.53-4.125 4.593h7.969v-.609c.031-1.266-.29-2.242-.961-2.93-.672-.703-1.633-1.054-2.883-1.054zM185.701 36c-.281-.516-.531-1.273-.75-2.273-1.453 1.828-3.484 2.742-6.094 2.742-2.39 0-4.421-.719-6.093-2.157-1.672-1.453-2.508-3.273-2.508-5.46 0-2.75 1.016-4.829 3.047-6.235 2.031-1.406 4.984-2.11 8.859-2.11h2.438v-1.335c0-2.328-1.008-3.492-3.024-3.492-1.875 0-2.812.922-2.812 2.765h-7.899c0-2.453 1.039-4.445 3.117-5.976 2.094-1.531 4.758-2.297 7.993-2.297 3.234 0 5.789.789 7.664 2.367 1.875 1.578 2.836 3.742 2.883 6.492v11.227c.031 2.328.39 4.11 1.078 5.344V36h-7.899zm-4.945-5.156c.984 0 1.797-.211 2.437-.633.657-.422 1.125-.898 1.407-1.43v-4.054h-2.297c-2.75 0-4.125 1.234-4.125 3.703 0 .718.242 1.304.726 1.758.485.437 1.102.656 1.852.656zM203.808 36h-7.922V0h7.922v36zm16.724-7.125c0-.672-.351-1.21-1.055-1.617-.703-.406-2.039-.828-4.007-1.266-1.969-.437-3.594-1.008-4.875-1.71-1.282-.72-2.258-1.587-2.93-2.602-.672-1.016-1.008-2.18-1.008-3.492 0-2.329.961-4.243 2.883-5.743 1.922-1.515 4.437-2.273 7.547-2.273 3.344 0 6.031.758 8.062 2.273 2.032 1.516 3.047 3.508 3.047 5.977h-7.922c0-2.031-1.07-3.047-3.211-3.047-.828 0-1.523.234-2.086.703-.562.453-.843 1.024-.843 1.711 0 .703.343 1.273 1.031 1.711.687.438 1.781.797 3.281 1.078 1.516.281 2.844.617 3.985 1.008 3.812 1.312 5.718 3.664 5.718 7.055 0 2.312-1.031 4.195-3.093 5.648-2.047 1.453-4.704 2.18-7.969 2.18-2.172 0-4.11-.39-5.813-1.172-1.703-.781-3.031-1.844-3.984-3.188-.953-1.343-1.43-2.757-1.43-4.242h7.383c.031 1.172.422 2.031 1.172 2.578.75.532 1.711.797 2.883.797 1.078 0 1.883-.219 2.414-.656.547-.438.82-1.008.82-1.711zm33.542-7.219l-12.75-4.336v-7.172l20.602 8.438v6.234l-20.602 8.438v-7.172l12.75-4.43z"
        fill="#80FCE3"
      />
    </svg>
  )
}

export const DealsSection = () => {
  return (
    <Container>
      <FlexWrapper to="/deals">
        <StaticImage
          src="../images/strain-unknown-001.jpg"
          alt="Cannabis plant close up."
          placeholder="blurred"
          style={{
            height: "50vh",          
          }}          
        />
        <Column>
          <SvgText opacity=".05" />
          <SvgText opacity=".10" />
          <SvgText opacity=".20" />
          <SvgText />
          <SvgText opacity=".20" />
          <SvgText opacity=".10" />
          <SvgText opacity=".05" />
        </Column>
      </FlexWrapper>
    </Container>
  )
}
